import Checkbox from "@mui/material/Checkbox";
import { Box } from "@mui/material";
import { CheckIcon } from "./icons";

const UncheckedIcon = ({ disabled }: { disabled?: boolean }) => (
  <Box
    component="span"
    sx={{
      width: 20,
      height: 20,
      borderRadius: "6px",
      border: "1px solid #D0D5DD",
      backgroundColor: "transparent",
      opacity: disabled ? 0.5 : 1,
    }}
  />
);

const CheckedIcon = ({
  color,
  disabled,
}: {
  color: string;
  disabled?: boolean;
}) => (
  <Box
    component="span"
    sx={{
      width: 20,
      height: 20,
      borderRadius: "6px",
      backgroundColor: color,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <CheckIcon />
  </Box>
);

const IndeterminateIcon = ({
  color,
  disabled,
}: {
  color: string;
  disabled?: boolean;
}) => (
  <Box
    component="span"
    sx={{
      width: 20,
      height: 20,
      borderRadius: "6px",
      backgroundColor: color,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: disabled ? 0.5 : 1,
    }}
  >
    <Box
      component="span"
      sx={{
        width: 10,
        height: 2,
        borderRadius: 1,
        backgroundColor: "#FFFFFF",
      }}
    />
  </Box>
);

interface IProps {
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  color?: string;
  inputProps?: any;
  disabled?: boolean;
}

const PrimaryCheckbox = ({
  checked,
  indeterminate,
  onChange,
  color = "var(--theme-primary-color, #2E3092)",
  inputProps,
  disabled,
}: IProps) => {
  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      icon={<UncheckedIcon disabled={disabled} />}
      checkedIcon={<CheckedIcon color={color} disabled={disabled} />}
      indeterminateIcon={
        <IndeterminateIcon color={color} disabled={disabled} />
      }
      inputProps={inputProps}
      disabled={disabled}
      disableRipple
      sx={{
        color: color,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        p: 0.25,
        "&.Mui-checked": {
          color: color,
        },
        "&.Mui-disabled": {
          color: color,
          opacity: 0.5,
        },
      }}
    />
  );
};

export { PrimaryCheckbox };
